import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
import { Award, BookOpen, Shield } from 'lucide-react';
export function PricingCards() {
  return <section id="pricing" className="scroll-mt-20 py-16 md:py-24 px-4 bg-surface-gray relative border-t border-gray-200" data-id="element-231">
      <div className="max-w-5xl mx-auto" data-id="element-232">
        <div className="text-center mb-16" data-id="element-233">
          <h2 className="text-3xl md:text-5xl font-black text-slate-dark" data-id="element-234">
            Elige Tu Acceso
          </h2>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto items-stretch" data-id="element-235">
          {/* Card A: Basic */}
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-white border border-gray-200 rounded-2xl p-8 flex flex-col h-full shadow-sm hover:shadow-md transition-shadow" data-id="element-236">
            <div className="mb-8" data-id="element-237">
              <BookOpen className="w-10 h-10 text-brand-green mb-6" data-id="element-238" />
              <h3 className="text-2xl font-black text-slate-dark mb-2" data-id="element-239">
                MEGAPACK BÁSICO
              </h3>
            </div>

            <div className="border-y border-gray-100 py-8 mb-8 flex-1 flex flex-col items-center justify-center" data-id="element-240">
              <p className="text-5xl font-black text-brand-green text-center leading-none" data-id="element-241">
                $490 <span className="text-2xl align-top" data-id="element-242">UYU</span>
              </p>
            </div>

            <CTAButton href="https://www.avanzapro.store/cart/48352083116257:1" className="mt-auto" data-id="element-243">
              🚀 QUIERO ACCEDER AHORA
            </CTAButton>
          </motion.div>

          {/* Card B: PRO */}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} whileInView={{
          opacity: 1,
          scale: 1
        }} viewport={{
          once: true
        }} className="bg-brand-dark border-2 border-brand-light rounded-2xl p-8 flex flex-col h-full relative shadow-xl md:scale-105 z-10" data-id="element-244">
            <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-brand-light text-white font-black px-6 py-1.5 rounded-full text-sm flex items-center gap-2 shadow-md whitespace-nowrap" data-id="element-245">
              <Award className="w-4 h-4" data-id="element-246" /> ⭐ MÁS POPULAR ⭐
            </div>

            <div className="mb-8 mt-4" data-id="element-247">
              <Shield className="w-10 h-10 text-brand-light mb-6" data-id="element-248" />
              <h3 className="text-2xl font-black text-white mb-2" data-id="element-249">
                MEGAPACK + CONTENIDO EXTRA
              </h3>
            </div>

            <div className="border-y border-white/10 py-8 mb-8 flex-1 flex flex-col items-center justify-center" data-id="element-250">
              <p className="text-6xl font-black text-white text-center leading-none" data-id="element-251">
                $790{' '}
                <span className="text-2xl align-top text-brand-light" data-id="element-252">UYU</span>
              </p>
            </div>

            <CTAButton href="https://www.avanzapro.store/cart/48352082264289:1" className="mt-auto !bg-brand-light !text-white" data-id="element-253">
              🚀 QUIERO ACCEDER AHORA
            </CTAButton>
          </motion.div>
        </div>
      </div>
    </section>;
}